import { Timestamp } from "firebase/firestore";
import Transaction from "../models/Transaction";
import { useEffect, useState } from "react";
import {getTransactionsOverTime} from "../_util/TransactionUtilities";
import { useModal } from "../_providers/ModalProvider";
import FormModal from "../_modals/FormModal";

const NextMonthImageDelta = ({transactions, canEdit, settings, onChangeSettings}: {transactions: Transaction[], canEdit: boolean, settings?: {[x: string]: any}, onChangeSettings: (newSettings: {[x: string]: any}) => void}) => {
    const [delta, setDelta] = useState(0);
    const [widgetData, setWidgetData] = useState(settings ? settings : {});
    const [valid, setValid] = useState(true);
    const {setModal} = useModal();

    const saveChanges = (newSettings: {[x: string]: any}) => {
        setWidgetData(newSettings);
        onChangeSettings(newSettings);
    };

    useEffect(() => {
        const incomes = transactions.filter((transaction) => transaction.type === "income");
        const expenses = transactions.filter((transaction) => transaction.type === "expense");

        const start = new Date();
        const end = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate());
        const transactionsOverTime = getTransactionsOverTime(incomes, start, end);
        const transactionsOverTimeExpenses = getTransactionsOverTime(expenses, start, end);

        let totalIncome = transactionsOverTime.reduce((acc, transaction) => {
            return acc + transaction.amount;
        }, 0);
        
        let totalExpenses = transactionsOverTimeExpenses.reduce((acc, transaction) => {
            return acc + transaction.amount;
        }, 0);

        setDelta(totalIncome - totalExpenses);
    }, [transactions]);
    return (
        <div className="widget" style={{height: "100%", boxSizing: "border-box", position: "relative"}}>
            {!valid || (delta >= 0 && !widgetData.goodImage) || (delta < 0 && !widgetData.badImage) ? <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>Add Image</div> :
                delta >= 0 ? (
                    <img src={widgetData?.goodImage} onLoad={() => setValid(true)} onError={() => setValid(false)} alt="Next Month Income" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                ) : (
                    <img src={widgetData?.badImage} onLoad={() => setValid(true)} onError={() => setValid(false)} alt="Next Month Income" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                )
            }
            {canEdit ? 
            <div onMouseDown={(e) => e.stopPropagation()} onClick={() => setModal("Update Widget Data", <FormModal data={widgetData} onCreate={(newData) => saveChanges(newData)} />)} style={{position: "absolute", right: 5, top: 5, zIndex: 9999, display: "flex", color: "white", justifyContent: "center", alignItems: "center", backgroundColor: "var(--primary-color)", borderRadius: 5, padding: 5}}>
                <i className="fa-solid fa-cog"/>
            </div> : null}
        </div>
    );
};

export default [NextMonthImageDelta, {w: 2, h: 3}, {goodImage: "", badImage: ""}] as const;